/* ── Synonym expansion ── */
const SYNONYMS = [
  ['miniatures', 'minis', 'scale models'],
];

function expandQuery(query) {
  const q = query.toLowerCase().trim();
  for (const group of SYNONYMS) {
    if (group.includes(q)) return group[0]; // normalise to canonical term
  }
  return query;
}

// Hook into predictive-search inputs
document.addEventListener('input', (e) => {
  if (e.target.matches('[data-predictive-search-input], input[name="q"]')) {
    const expanded = expandQuery(e.target.value);
    if (expanded !== e.target.value) e.target.value = expanded;
  }
}, true);

/* ── Auto-focus search on desktop ── */
const mq = window.matchMedia('(min-width: 768px)');
if (mq.matches) {
  const searchInput = document.querySelector('[data-predictive-search-input], input[name="q"]');
  if (searchInput) searchInput.focus();
}

// Also focus when search icon/button is clicked
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-open-search], .search-toggle, [aria-label*="Search"]')) {
    setTimeout(() => {
      const inp = document.querySelector('[data-predictive-search-input]');
      if (inp) inp.focus();
    }, 100);
  }
});

/* ── "Back to results" link on PDPs ── */
if (window.location.pathname.startsWith('/products/') && document.referrer.includes('/search')) {
  const link = document.createElement('a');
  link.href = document.referrer;
  link.textContent = '← Back to results';
  link.style.cssText = 'display:inline-block;margin:12px 0;font-size:0.875rem;opacity:0.75;';
  const target = document.querySelector('.product__info-wrapper, .product-single, main');
  if (target) target.prepend(link);
}
